import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Section from '../components/Section';
import { API } from '../api';

/**
 * Landing page for the /account/callback redirect from backend SocialController
 * (issued when the OAuth launch carried ?client=web). Reads email+provider from
 * the query string, calls /v2/social to trade for a bearer token, then bounces
 * back into /account.
 */
export default function AccountCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [msg, setMsg] = useState('Signing you in…');

  useEffect(() => {
    const email = params.get('email');
    const provider = params.get('provider') || 'google';
    const token = params.get('token') || '';
    if (!email || !token) { setMsg('Missing sign-in token from the provider.'); return; }
    (async () => {
      const r = await API.socialLogin(email, provider, token);
      if (r.success) { nav('/account', { replace: true }); }
      else setMsg(r.message || 'Sign-in failed. Please try again.');
    })();
  }, [params, nav]);

  return (
    <Section chip="Account" title={msg} subtitle="Establishing a secure session on this browser.">
      <div className="mx-auto w-16 h-16 rounded-full border-4 border-[color:var(--color-brand)]/25 border-t-[color:var(--color-brand)] animate-spin" />
    </Section>
  );
}
